var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookBlack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 3.66667V17M10.3333 3.66667C10.7216 3.14949 11.225 2.7298 11.8035 2.44081C12.3821 2.15182 13.02 2.00147 13.6667 2.00167L17.0008 2C17.4427 2.00022 17.8664 2.17591 18.1788 2.48845C18.4912 2.80099 18.6667 3.22478 18.6667 3.66667V4.5M18.6667 12.5467V13.6667C18.6667 14.1085 18.4912 14.5323 18.1788 14.8449C17.8664 15.1574 17.4427 15.3331 17.0008 15.3333H13.6667C13.0198 15.3333 12.3818 15.4839 11.8033 15.7732C11.2247 16.0625 10.7214 16.4825 10.3333 17C9.94522 16.4825 9.44195 16.0625 8.86339 15.7732C8.28483 15.4839 7.64685 15.3333 7 15.3333H3.66583C3.22395 15.3331 2.80024 15.1574 2.48786 14.8449C2.17548 14.5323 2 14.1085 2 13.6667V3.66667C2 3.22464 2.17559 2.80072 2.48816 2.48816C2.80072 2.17559 3.22464 2 3.66667 2H7C7.64685 2 8.28483 2.1506 8.86339 2.43989C9.44195 2.72917 9.94522 3.14918 10.3333 3.66667M13.6667 9.5L15.3333 11.1667L18.6667 7.83333",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBlack);
export default __webpack_public_path__ + "static/media/Book_black.14ea1c628713054c0e02c67b5825c0c4.svg";
export { ForwardRef as ReactComponent };